import * as React from "react";
const SvgMVideo = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}><path d="M0 0h24v24H0z" data-name="Trazado 524" style={{
    fill: "none"
  }} /><path d="M5.76 10H20v8H4V6.47M22 4h-4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4a2.006 2.006 0 0 0-2 2v12a2.006 2.006 0 0 0 2 2h16a2.006 2.006 0 0 0 2-2z" data-name="Trazado 525" /></svg>;
export { SvgMVideo as ReactComponent };